import React, { useState, useEffect } from "react";
import { userService } from "../../_services";
import { FormDialog } from "../ui/form-dialog";
import { Label } from "../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { AlertCircle, Loader2 } from "lucide-react";

/**
 * Price Setup Modal
 * Modernized with shadcn Dialog and Select components
 */
function Price_setup_pop({ 
    close_setup, 
    submit_Setup_Detail, 
    titleText, 
    detailText, 
    btnText, 
    subDomain, 
    groupNumber 
}) {
    const [groupNumbers, setGroupNumbers] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(groupNumber || '');
    const [selectedGroupError, setSelectedGroupError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        const [userId, userName] = Usermeta_Data.split(':');
        fetchGroupNumberList(userId, userName);
    }, []);

    const fetchGroupNumberList = async (userId, userName) => {
        try {
            const apidata = await userService.GetGroupNumberList(userId, userName);
            setGroupNumbers(apidata || []);
        } catch (error) {
            console.error('Error fetching group numbers:', error);
            setGroupNumbers([]);
        }
    };

    const handleSubmit = async () => {
        // Validation
        if (!selectedGroup || selectedGroup === '' || selectedGroup === 'Select your favourite group number') {
            setSelectedGroupError('Select your favourite group number');
            return;
        }

        setLoading(true);

        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const userId = Usermeta_Data.split(':')[0];

            const apidata = await userService.PricingToolInitialStatus(userId, '-', selectedGroup, 'Submit');

            if (apidata && apidata.length > 0) {
                if (apidata[0].message === 'Success') {
                    const newSubDomain = apidata[0].subDomain;
                    submit_Setup_Detail(newSubDomain, selectedGroup, 'Submitted');
                } else {
                    setSelectedGroupError(apidata[0].message);
                    close_setup();
                }
            } else {
                setSelectedGroupError('Error! Please try later.');
            }
        } catch (error) {
            setSelectedGroupError('Error! Please try later.');
            console.error('Error submitting price setup:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        close_setup();
    };

    const handleGroupChange = (value) => {
        setSelectedGroup(value);
        setSelectedGroupError('');
    };

    return (
        <FormDialog
            open={true}
            onOpenChange={handleClose}
            title={titleText}
            description={detailText}
            onSubmit={handleSubmit}
            onCancel={handleClose}
            submitText={btnText || "Submit"}
            loading={loading}
            maxWidth="md"
        >
            <div className="space-y-4">
                <div className="space-y-2">
                    <Label htmlFor="groupNumber">Group Number</Label>
                    <Select value={selectedGroup} onValueChange={handleGroupChange}>
                        <SelectTrigger 
                            id="groupNumber" 
                            className={selectedGroupError ? "border-red-500" : ""}
                        >
                            <SelectValue placeholder="Select your group number" />
                        </SelectTrigger>
                        <SelectContent>
                            {groupNumbers.length > 0 ? (
                                groupNumbers.map((team) => (
                                    <SelectItem key={team.value} value={team.value}>
                                        {team.display}
                                    </SelectItem>
                                ))
                            ) : (
                                <div className="flex justify-center py-2">
                                    <Loader2 className="h-4 w-4 animate-spin text-brand-accent" />
                                </div>
                            )}
                        </SelectContent>
                    </Select>
                    {selectedGroupError && (
                        <p className="text-sm text-red-500 flex items-center gap-1">
                            <AlertCircle className="h-3 w-3" />
                            {selectedGroupError}
                        </p>
                    )}
                </div>
            </div>
        </FormDialog>
    );
}

export default Price_setup_pop;
